import { render, staticRenderFns } from "./HeaderSearchAlgolia.vue?vue&type=template&id=40a6a898"
import script from "./HeaderSearchAlgolia.vue?vue&type=script&lang=js"
export * from "./HeaderSearchAlgolia.vue?vue&type=script&lang=js"
import style0 from "./HeaderSearchAlgolia.vue?vue&type=style&index=0&id=40a6a898&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports